var Glyphicon = require("components/utility/icons/Glyphicon");

require("utility/teacher_preview_notice.scss");

var TeacherPreviewNotice = function(props) {
	return (
		<div className="teacherPreviewNotice">
			<Glyphicon icon="eye-open" /> You are previewing what this
			page will look like for your students.
			{ props.children }
		</div>
	);
};

TeacherPreviewNotice.propTypes = StrictPropTypes({
	// Components to render inside the container
	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]).isRequired,

});

module.exports = TeacherPreviewNotice;


// WEBPACK FOOTER //
// ./modules/components/utility/TeacherPreviewNotice.js